/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Subtitle,
    SubtitleFromJSON,
    SubtitleFromJSONTyped,
    SubtitleToJSON,
} from './';

/**
 * 
 * @export
 * @interface EditorSubtitle
 */
export interface EditorSubtitle {
    /**
     * 
     * @type {number}
     * @memberof EditorSubtitle
     */
    file?: number;
    /**
     * 
     * @type {number}
     * @memberof EditorSubtitle
     */
    parent?: number;
    /**
     * 
     * @type {string}
     * @memberof EditorSubtitle
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EditorSubtitle
     */
    format?: string;
    /**
     * 
     * @type {Subtitle}
     * @memberof EditorSubtitle
     */
    subtitle: Subtitle;
}

export function EditorSubtitleFromJSON(json: any): EditorSubtitle {
    return EditorSubtitleFromJSONTyped(json, false);
}

export function EditorSubtitleFromJSONTyped(json: any, ignoreDiscriminator: boolean): EditorSubtitle {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': !exists(json, 'file') ? undefined : json['file'],
        'parent': !exists(json, 'parent') ? undefined : json['parent'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'format': !exists(json, 'format') ? undefined : json['format'],
        'subtitle': SubtitleFromJSON(json['subtitle']),
    };
}

export function EditorSubtitleToJSON(value?: EditorSubtitle | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': value.file,
        'parent': value.parent,
        'name': value.name,
        'format': value.format,
        'subtitle': SubtitleToJSON(value.subtitle),
    };
}


